export const USER_PATIENT_UPDATE="/user/patient/update";
export const USER_DOCTOR_UPDATE="/user/doctor/update";
export const USER_DEVELOPER_UPDATE="/user/developer/update";
export const USER_PHONE="/user/phone";
export const USER_INFO="/user/info";
export const USER_DOCTOR_CERTIFY="/user/doctor/certify";
export const USER_INTEGRAL="/user/integral";
export const USER_CERTAIN_INFO="/user/certain/info";
export const USER_DOCTOR_LIST="/user/doctor/list";
export const USER_ARTIFICIAL="/user/artificial";
export const USER_WAITREQUEST="/user/waitrequest";
export const USER_REQUEST="/user/request";
export const USER_CANCEL_REQUEST="/user/cancel/request";
export const USER_REQUEST_ACCEPT="/user/request/accept";
export const USER_REQUEST_REJECT="/user/request/reject";
export const USER_HISTORY="/user/history";
export const USER_ADMIN_UPDATE="/user/admin/update";